import { render } from "./address.vue?vue&type=template&id=4d210687&scoped=true&ts=true"
import script from "./address.vue?vue&type=script&lang=ts"
export * from "./address.vue?vue&type=script&lang=ts"

import "./address.vue?vue&type=style&index=0&id=4d210687&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d210687"]])

export default __exports__